export default {"src":"/_next/static/media/startup-logo4.1adc95fc.svg","height":107,"width":600,"blurWidth":0,"blurHeight":0};